export default __webpack_public_path__ + "static/media/TransportationCars_08.cf649328.png";